if (!customElements.get('arb-us-coupon')) {
  customElements.define('arb-us-coupon', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.querySelector('[data-copy-code]')?.addEventListener('click', async () => {
        const status = this.querySelector('[role="status"]');
        try {
          await navigator.clipboard.writeText(this.dataset.code);
          status.textContent = 'Code copied. It will also apply when you add to cart.';
        } catch {
          status.textContent = `Use code ${this.dataset.code} at checkout.`;
        }
      }, { signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
